import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '../iconVariant';
import { IconProps } from '../types/IconInterface';

// The small icon on the circle avatar of the transaction details in this design:
// https://www.figma.com/design/bblnSSOHdRw4VImNVChx2K/Emerge-Customer-Web-Portal?node-id=6114-32811&t=dK9bbYlUWIaMxydA-4
const ReceiptNotProvidedIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 9 11">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.200195 1.49998C0.200195 1.00292 0.603139 0.599976 1.1002 0.599976H5.2274C5.4661 0.599976 5.69502 0.694797 5.8638 0.86358L8.33659 3.33637C8.50537 3.50515 8.6002 3.73407 8.6002 3.97277V9.29998C8.6002 9.79703 8.19725 10.2 7.7002 10.2H1.1002C0.603139 10.2 0.200195 9.79703 0.200195 9.29998V1.49998ZM3.61391 3.96869C3.39675 3.75153 3.04466 3.75153 2.8275 3.96869C2.61034 4.18585 2.61034 4.53794 2.8275 4.7551L3.61391 5.54151L2.8275 6.32791C2.61034 6.54507 2.61034 6.89716 2.8275 7.11432C3.04466 7.33148 3.39675 7.33148 3.61391 7.11432L4.00711 6.72112L4.40032 6.32791L5.18672 7.11432C5.40388 7.33148 5.75597 7.33148 5.97313 7.11432C6.19029 6.89716 6.19029 6.54507 5.97313 6.32791L5.18672 5.54151L5.97313 4.7551C6.19029 4.53794 6.19029 4.18585 5.97313 3.96869C5.75597 3.75153 5.40388 3.75153 5.18672 3.96869L4.40032 4.7551L3.61391 3.96869Z"
      fill="currentColor"
    />
  </svg>
);

export default ReceiptNotProvidedIcon;
